import React from "react";
import UserProfileNextIcon from "../Icons/UserProfileNextIcon";
import { useNavigate } from "react-router-dom";

interface IUserProfileMenu {
  icon: React.ReactNode;
  text: string;
  className?: string;
  navigateTo: string;
  disable?: boolean;
}

const UserProfileMenu = (prop: IUserProfileMenu) => {
  const { icon, text, className, navigateTo, disable } = prop;
  const navigate = useNavigate();


  const handleClick = () => {
    if (!disable) {
      navigate(navigateTo);
    }
  };

  return (
    <div
      className={`flex justify-between py-4 px-3 bg-white border border-taupe-1 rounded-lg
        hover:bg-gray-5 cursor-pointer ${className}`}
      onClick={handleClick}
    >
      <div className="flex gap-2">
        {icon}
        {text}
      </div>
      <div className="flex items-center">
        <UserProfileNextIcon />
      </div>
    </div>
  );
};

export default UserProfileMenu;
